import { queryOptions, type QueryClient } from "@tanstack/react-query";
import { nicknameApi } from "~/src/apis/secure-chat/nickname";
import { QUERY_KEY } from "~/src/constants/queryKeys";
import { type NicknamesResponse } from "~/src/models/secure-chat";

export const nicknamePageKey = (accountId: string): string[] => [
  QUERY_KEY.nicknames,
  "page",
  accountId,
];
export const nicknamePageQueryOptions = (
  accountId: string,
  page: number
): ReturnType<typeof queryOptions<NicknamesResponse>> =>
  queryOptions<NicknamesResponse>({
    queryKey: [...nicknamePageKey(accountId), page],
    queryFn: async ({ signal }) =>
      (await nicknameApi.getNickNames(page, signal)).data,
    enabled: !!accountId,
    staleTime: 5 * 60_000,
    gcTime: 10 * 60_000,
  });

/** Invalidate shared pages before either projection refetches them. */
export async function invalidateNicknameCaches(
  client: QueryClient,
  accountId: string
): Promise<void> {
  await client.cancelQueries({ queryKey: nicknamePageKey(accountId) });
  await client.invalidateQueries({
    queryKey: nicknamePageKey(accountId),
    refetchType: "none",
  });
  await Promise.all([
    client.invalidateQueries({
      queryKey: nicknamePageKey(accountId),
    }),
    client.invalidateQueries({
      queryKey: [
        QUERY_KEY.accountSetting,
        QUERY_KEY.nicknames,
        QUERY_KEY.list,
        accountId,
      ],
    }),
  ]);
}
